import React, { useEffect } from 'react';
import ManufactureUnitForm from './create';
import { useHook as manufactureUnitHook } from './useHook';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Unauthorized } from '../../../components/index';
import { ErrorMessage } from '../../../permissionErrorMessage/PermissionMessage';
interface Props {
  pagePermissionIDs: unknown;
}
const Edit: React.FC<Props> = ({ pagePermissionIDs }) => {
  const canGetUnit =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('units::get');
  const canEquipmentlistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('equipments::list');
  const canGetEquipment =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('equipments::get');

  const requiredAccess = (
    <section className="required_access_section">
      <p>you require below access:</p>
      <ul>
        <li>{ErrorMessage['units::get'] || ''}</li>
        <li>{ErrorMessage['equipments::list'] || ''}</li>
        <li>{ErrorMessage['equipments::get'] || ''}</li>
      </ul>
    </section>
  );
  const { id } = useParams();
  const { fetchGetUnitDetails } = manufactureUnitHook();
  const { unitDetails } = useSelector((state: any) => state.manufactureUnit);

  const handleUnitDetails = async () => {
    await fetchGetUnitDetails({ unitID: id });
  };
  useEffect(() => {
    if (canGetUnit && canEquipmentlistPermission && canGetEquipment) {
      handleUnitDetails();
    }
  }, [canGetUnit, canEquipmentlistPermission, canGetEquipment]);
  return (
    <>
      {!canGetUnit || !canEquipmentlistPermission || !canGetEquipment ? (
        <Unauthorized requiredAccess={requiredAccess} />
      ) : (
        <ManufactureUnitForm editData={unitDetails} />
      )}
    </>
  );
};

export default Edit;
